"use strict";
exports.__esModule = true;
exports.formatBytes = exports.fileDownload = void 0;
var constants_1 = require("./constants");
// TODO - Figure out how to achieve fileDownload without DOM interaction
/**
 * Function to create a download hyperlink and initiate file download
 * @param file the file data (blob) which is to be downloaded
 * @param filename name of the file w/ its extension
 */
exports.fileDownload = function (fileData, filename) {
    var file = window.URL.createObjectURL(fileData);
    var downloadLink = document.createElement('a');
    downloadLink.setAttribute('id', 'downloadLink');
    downloadLink.download = filename;
    downloadLink.href = file;
    downloadLink.click();
    var myElement = document.getElementById('downloadLink');
    if (myElement !== null) {
        myElement.remove();
    }
};
/**
 * Function to convert bytes to readable sizes
 * @param bytes the size of the file
 */
exports.formatBytes = function (bytes) {
    if (bytes === 0)
        return constants_1.DEFAULT_FILE_SIZE;
    var decimals = 2;
    var byteSize = 1024;
    var units = ['b', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'ab', 'yb'];
    // Divide the log of incoming bytes with byteSize and fetches the power
    var powerOf = Math.floor(Math.log(bytes) / Math.log(byteSize));
    // Divide bytes with byteSize raised to the power of i and attach the unit
    var convertedValue = parseFloat((bytes / Math.pow(byteSize, powerOf)).toFixed(decimals)) + " " + units[powerOf];
    return convertedValue;
};
